import { Page } from '@7shifts/sous-chef';
import MessageTemplateForm from '../components/MessageTemplateForm/MessageTemplateForm';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { __ } from 'i18n/translate';

const MessageTemplatesNewPage = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const [breadcrumbs, setBreadcrumbs] = useState({
        url: `/message-templates/?channelId=${id}`,
        label: __('main.modelMessages')
    });
    const from = searchParams.get('from');

    useEffect(() => {
        if (!id) {
            throw new Error('No queue ID present');
        }

        if (from === 'campaign') {
            setBreadcrumbs({
                url: `/campaigns/new`,
                label: __('campaignsPage.newCampaign')
            });
        }
    }, [from, id]);

    return (
        id && (
            <Page
                title={__('messageTemplateForm.titleForm')}
                breadcrumbs={breadcrumbs}
            >
                <MessageTemplateForm whatsappId={Number(id)} />
            </Page>
        )
    );
};

export default MessageTemplatesNewPage;
